import React, { useState, useEffect } from "react";
import Career_Banner from "./career-banner/Career_Banner";
import What_Is_Counselling from "./what-is-counselling/What_Is_Counselling";
import Counselling_Process from "./counselling-process/Counselling_Process";
import Opt_For_Counselling from "./opt-for-counselling/Opt_For_Counselling";
import Start_Assessment from "./start-assessment/Start_Assessment";
import { useSelector, useDispatch } from "react-redux";
import { GetAllCareerBanner } from "../../features/components/careercounselling/careerbanner/Slice";
import { GetAllCareerProcess } from "../../features/components/careercounselling/careerprocess/Slice";
import { GetAllWhatCareer } from "../../features/components/careercounselling/whatcareer/Slice";
import { GetAllWhoShouldOpt } from "../../features/components/careercounselling/whoshouldopt/Slice";
import { IDS } from "../../utils/IDS";

const Career_Counselling = () => {
  const dispatch = useDispatch();

  const banner = useSelector(
    (state) => state?.careercounselling?.careerbanner?.all_careerbanner?.data?.[0],
  );

  const whatcareer = useSelector(
    (state) => state?.careercounselling?.whatcareer?.all_whatcareer?.data?.[0],
  );
  
  const careerprocess = useSelector(
    (state) => state?.careercounselling?.careerprocess?.all_careerprocess?.data || []
  );

  const whoshouldopt = useSelector(
    (state) => state?.careercounselling?.whoshouldopt?.all_whoshouldopt?.data || []
  );

  useEffect(() => {
    dispatch(GetAllCareerBanner());
    dispatch(GetAllWhatCareer());
    dispatch(GetAllCareerProcess());
    dispatch(GetAllWhoShouldOpt());
  }, [dispatch]);

  return (
    <>
      <Career_Banner banner={banner} />
      <What_Is_Counselling whatcareer={whatcareer} />
      <Counselling_Process careerprocess={careerprocess} />
      <Opt_For_Counselling whoshouldopt={whoshouldopt}/>
      <Start_Assessment />
    </>
  );
};

export default Career_Counselling;
